import { QuestionIds } from '../constants/QuestionIds';
import { Steps } from '../constants/StepsLabels';
import { PersonalizationSectionQuestionIds } from '../PersonalizationQuestionIds';

export const EducationV3TestSteps: Map<Steps, QuestionIds[]> = new Map([
  [
    Steps.Quiz,
    [
      QuestionIds.EduQ1,
      QuestionIds.EduQ1Answer,
      QuestionIds.EduQ2,
      QuestionIds.EduQ2Answer,
      QuestionIds.EduQ3,
      QuestionIds.EduQ3Answer,
      QuestionIds.EduQ4,
      QuestionIds.EduQ4Answer,
      QuestionIds.EduQ5,
      QuestionIds.EduQ5Answer,
    ],
  ],
  [
    Steps.Sleep,
    [
      QuestionIds.RMeqQ1,
      QuestionIds.RMeqQ2,
      QuestionIds.RMeqQ3,
      QuestionIds.RMeqQ4,
      QuestionIds.RMeqQ5,
      QuestionIds.AboutYouProof1,
    ],
  ],
  [
    Steps.AboutYou,
    [
      QuestionIds.AboutYouGender,
      QuestionIds.AboutYouAge,
      QuestionIds.AboutYouRoutine,
      QuestionIds.AboutYouKids,
      QuestionIds.AboutYouActivity,
      QuestionIds.SleepAndActivityProof2,
      QuestionIds.SleepAndActivityCoffee,
      QuestionIds.SleepAndActivityDinner,
      QuestionIds.SleepAndActivityAfterMidnight,
      QuestionIds.SleepAndActivityLessThanEightHours,
      QuestionIds.SleepAndActivityExtraMotivation,
    ],
  ],
  [Steps.Personalization, PersonalizationSectionQuestionIds],
]);
